/**
 *
 */
import { get, post ,del,put} from 'mdoc/admin/axios/tools'
import * as config from 'mdoc/admin/axios/config'

//お知らせ配信一覧
export const getNotifySearch = (param) => new Promise((resolve, reject)=> {
    get(config.NOTIFY_SEARCH, param)
        .then(function (response) {
            resolve({results: response.docTblNoticeList, count: response.count})
        }).catch(function (error) {
        reject(error);
    })
})
//お知らせ配信一覧削除
export const notifyDelete = (id,param) => new Promise((resolve, reject)=> {
    del(config.NOTIFY_DELETE+'/'+id, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})
// お知らせ配信详细
export const notifyDetail = (id,param) => new Promise((resolve, reject)=> {
    get(config.NOTIFY_DETAIL+'/'+id, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})
// お知らせ配信新规登録
export const notifyLogin = (param) => new Promise((resolve, reject)=> {
    post(config.NOTIFY_LOGIN, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})
// お知らせ配信更新登録
export const notifyUpdate = (param) => new Promise((resolve, reject)=> {
    put(config.NOTIFY_UPDATE, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})